var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{ref:"wrapperRef"},[_c('AlternativeProductInquiryBlock',{style:(_vm.stickyStyle)})],1),_vm._v(" "),_c('ProductInquiry')],1)}
var staticRenderFns = []

export { render, staticRenderFns }